function initToolProduct(root){if(root.dataset.caReady)return;root.dataset.caReady='true';const radios=root.querySelectorAll('input[type="radio"]');const qty=root.querySelector('[data-ca-quantity]');radios.forEach(r=>r.addEventListener('change',()=>{if(qty)qty.value=r.value}));const selected=root.querySelector('input[type="radio"]:checked');if(qty&&selected)qty.value=selected.value}document.querySelectorAll('[data-ca-product]').forEach(initToolProduct);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ca-product]').forEach(initToolProduct));
{
  const desktop = window.matchMedia('(min-width: 900px)');
  let placement;
  function syncFeatureVideo() {
    if (placement) {
      const { section, video, marker, grid } = placement;
      if (marker.isConnected) marker.replaceWith(video);
      section.hidden = false;
      grid.classList.remove('tool-video-grid');
      placement = undefined;
    }
    if (!desktop.matches) return;
    const section = document.querySelector('main .tool-video');
    const video = section?.querySelector('video');
    const grid = document.querySelector('main #features .ca-card-grid');
    if (!video || !grid || grid.children.length !== 4) return;
    const marker = document.createComment('Original video position');
    video.before(marker);
    grid.append(video);
    grid.classList.add('tool-video-grid');
    section.hidden = true;
    placement = { section, video, marker, grid };
  }
  desktop.addEventListener('change', syncFeatureVideo);
  document.addEventListener('shopify:section:load', syncFeatureVideo);
  syncFeatureVideo();
}

{
  function updateMultiToolSticky() {
    const sticky = document.querySelector('[data-multitool-sticky]');
    if (!sticky) return;
    const button = document.querySelector('[data-multitool] .ca-buy');
    const bounds = button?.getBoundingClientRect();
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    sticky.hidden = !bounds || bounds.bottom > 0 || scrollable <= 0 || window.scrollY <= scrollable / 2;
  }
  window.addEventListener('scroll', updateMultiToolSticky, { passive: true });
  window.addEventListener('resize', updateMultiToolSticky);
  window.addEventListener('load', updateMultiToolSticky);
  document.addEventListener('shopify:section:load', updateMultiToolSticky);
  updateMultiToolSticky();
}
